import LabelRequired from '../../component/LabelRequired';
import { formatPatientRowData } from '../../phan-he-kham-benh/utils/Utils';
import { formatBirthdate } from '../../utils/FormatUtils';

type Props = {
	patientInfo: any;
	visitCode: string;
	provisionalDiagnosis?: string;
};

const PatientInfo = ({ patientInfo, visitCode, provisionalDiagnosis }: Props) => {
	return (
		<>
			<div className="d-flex spaces mb-6">
				<LabelRequired label="Bệnh nhân:" className="spaces w-22 fw-bold" />
				<div className="flex-grow-1 text-truncate">
					{patientInfo?.personName
						? formatPatientRowData([
								patientInfo?.code,
								patientInfo?.personName,
								patientInfo?.gender,
								formatBirthdate(patientInfo?.ageText, patientInfo?.dobYear),
						  ])
						: '...'}
				</div>
			</div>
			<div className="d-flex spaces mb-6">
				<LabelRequired label="Mã vào khám:" className="spaces w-22 fw-bold" />
				<div className="flex-grow-1 text-truncate">{visitCode || '...'}</div>
			</div>
			<div className="d-flex spaces mb-6">
				<LabelRequired label="Chẩn đoán:" className="spaces w-22 fw-bold" />
				<div className="flex-grow-1 text-truncate">{provisionalDiagnosis || '...'}</div>
			</div>
		</>
	);
};

export default PatientInfo;
